<template lang="pug">
    ul(:class="[ look.wrapper, shit$(look.wrapper) ]")
        template(v-for="(item, index) in list")
            template(v-if="item === 'slot$'")
                slot(name="slot$")
            template(v-else)
                template(v-if="slotItemWrapperStr && isItemWrapperIndex === index")
                    slot(:name="slotItemWrapperStr", :item="item", :index="index")
                template(v-else)
                    li(:class="[ look.item, shit$(look.item), shit$(item.active$), shit$(item.disabled$)]"
                        @click="() => item.disabled$ || $emit('childClick', item)",
                        @mousedown="() => item.disabled$ || $emit('childMousedown', { item, index })"
                        :key="index")
                            template(v-if="slotItemStr && index === isItemIndex")
                                slot(:name="slotItemStr", :listItem="item", :listItemIndex="index")
                            template(v-else)
                                span {{ item['label'] }}
</template>

<script>
export default {
    name: 'publoic-custom-list',
    props: {
        list: Array,
        look: Object,
        slotItemStr: String,
        slotItemWrapperStr: String,
        isItemWrapperIndex: Number,
        isItemIndex: Number,
    }
}
</script>
